import { useCallback, useEffect } from 'react';
import useRequestContext from '../context/requestContext';
import { getMunicipalitiesTree } from '../Services/httpCalls';

export default function useMunicipalities() {
  const { municipalities, setMunicipalities } = useRequestContext();

  const getMunicipalitieData = useCallback(async () => {
    const res = await getMunicipalitiesTree();

    if (res) {
      setMunicipalities(res.municipalities);
    }
  }, [setMunicipalities]);

  useEffect(() => {
    if (municipalities.length > 0) return;

    getMunicipalitieData();
  }, []);

  return { municipalities };
}
